/* eslint-disable */

class _BaseDataCenter {
  constructor(key, rootVue) {
    this._rootVue = rootVue;
    this._component = {};
    this._key = key || 'baseDataCenter';
    this._proxyObject = _ProxyBaseDataCenter;
    this._watchItemInited = false;
    this._watchListInited = false;
  }
  _getVueComponentUKey(vueComponent) {
    return vueComponent._uid || vueComponent.name
  }
  _register(ukey) {
    console.debug('_register', ukey)
    if (this._component[ukey]) {
      return
    }
    // i: [{cb:func, id: number}]
    // l: [{cb:func, args:{} ]
    this._component[ukey] = {'l': [], 'i': []}
  }
  unregister(ukey) {
    console.debug('_unregister', ukey)
    delete this._component[ukey]
  }
  getList(...args) {

  }
  getItem(id) {

  }

  _initWatchItem(events) {
    this._watchItemInited = true;
    this._rootVue.$on(events, (data) => {
      Object.values(this._component).forEach(x => {
        x.i.forEach(y => {
          if(y.id === data.id) {
            y.cb(this.getItem(data.id))
          }
        })
      })}
    )
  }

  _initWatchList(events) {
    this._watchListInited = true;
    this._rootVue.$on(events, () => {
      Object.values(this._component).forEach(x => {
        x.l.forEach(y => {
          y.cb(this.getList(...y.args))
        })
      })}
    )
  }

  watchItem(ukey, cb, id) {
    if (!this._watchItemInited) {
      console.error(this._key, 'watch Item: initialization')
    }
    if(!this._component[ukey]) {
      this._register(ukey)
    }
    this._component[ukey].i.push({cb, id})
    cb(this.getItem(id))
  }
  watchList(ukey, cb, ...args) {
    if (!this._watchListInited) {
      console.error(this._key, 'watch list: no initialization')
    }
    if(!this._component[ukey]) {
      this._register(ukey)
    }
    this._component[ukey].l.push({cb, args})
    cb(this.getList(...args))
  }

  autoRegisterMixin() {
    const that = this;
    return {
      data() {
        return {
          [that._key]: new that._proxyObject(that, this),
          _dataCenterKey: that._getVueComponentUKey(this)
        }
      },
      destroyed() {
        that.unregister(this._dataCenterKey)
      },
      deactivated() {
        that.unregister(this._dataCenterKey)
      }
    }
  }
}

function _ProxyBaseDataCenter(dataCenter, vueComponent) {
  const ukey = vueComponent._uid || vueComponent.name
  const proxy = {
    watchItem: function (cb, id){
      dataCenter.watchItem(ukey, cb, id)
    },
    watchList: function (cb, ...args) {
      dataCenter.watchList(ukey, cb, ...args)
    }
  }
  proxy.__proto__ = dataCenter;
  return proxy;
}

export const BaseDataCenter = _BaseDataCenter;
